import {
  RealtimeEventType,
  type RealtimeEventCbCancel,
  type RealtimeEvent,
  type RealtimePresenceEvent,
  RealtimeRole,
} from '@doxyme/realtime';
import {
  type RealtimeMessage,
  type RealtimeOnMessageProps,
  type LegacyMessage,
} from './realtime.types';
import { realtimeInstance } from './realtime.slice';

export const subscribeToMessage = ({
  callback,
  messageType,
}: RealtimeOnMessageProps): RealtimeEventCbCancel => {
  const unsubscribe = realtimeInstance.on(
    [RealtimeEventType.Message],
    (event: RealtimeEvent) => {
      const messageEvent = event.data as RealtimeMessage;
      if (messageEvent.messageType === messageType) {
        if (Boolean(messageEvent.requestAck)) {
          realtimeInstance
            .acknowledgeMessage(event)
            .catch((error) =>
              console.warn(
                '[realtime.subscribeToMessage] failed to ack message',
                error,
              ),
            );
        }

        callback(messageEvent, event);
      }
    },
  );

  return unsubscribe;
};

export const subscribeToLegacyMessage = ({
  callback,
  messageType,
}: RealtimeOnMessageProps): RealtimeEventCbCancel => {
  const unsubscribe = realtimeInstance.on(
    [RealtimeEventType.Message],
    (event: RealtimeEvent) => {
      const eventData = event.data as LegacyMessage | RealtimeMessage;

      if ('message' in eventData) {
        const { message } = eventData;
        // Even though the typings suggest that system (server) messages should have a component name - they don't. They only come through with an action, why - OG typings that's why :-(.
        const eventId =
          event.from.role === RealtimeRole.System
            ? message.action
            : `${message.componentName}:${message.action}`;
        if (eventId === messageType) {
          callback(
            {
              messageType,
              payload: message.content,
              requestAck: message.requestAck,
              messageId: message.messageId,
            },
            event,
          );
        }
      }
    },
  );

  return unsubscribe;
};

export const subscribeToLeave = (
  callback: (event: RealtimePresenceEvent) => void,
): RealtimeEventCbCancel => {
  return realtimeInstance.on([RealtimeEventType.Leave], (event) => {
    callback(event as RealtimePresenceEvent);
  });
};
